import { Dayjs } from 'dayjs';

export enum ModalType {
  PipeLoss = 1,
  FlowMeter = 2,
  other = 0,
}
export enum TimeActive {
  THIS_MONTH = 'MONTH',
  THIS_YEAR = 'YEAR',
  THIS_DAY = 'DAY',
  THIS_WEEK = 'WEEK',
}
export type RangeValue = [Dayjs, Dayjs];
